import { render, staticRenderFns } from "./OffsetBase.vue?vue&type=template&id=cb152f80&"
import script from "./OffsetBase.vue?vue&type=script&lang=ts&"
export * from "./OffsetBase.vue?vue&type=script&lang=ts&"
import style0 from "./OffsetBase.vue?vue&type=style&index=0&id=cb152f80&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports